(function() { window.GUID_dd59e95d_0401_49df_a3ee_c03ac3030e8b = { getGuid: function() { return "dd59e95d-0401-49df-a3ee-c03ac3030e8b"; } }; })();
var GoogleAds;
(function (GoogleAds) {
    function BindAds(enabled) {
        if (enabled) {
            $(function () {
                try {
                    if (CS.GlobalConst.UseGoogleAdsense) {
                        var adsByGoogle = (adsByGoogle = window.adsbygoogle || []);
                        $('.adsbygoogle').each(function () { adsByGoogle.push(this); });
                    }
                }
                catch (e) {
                }
            });
        }
    }
    GoogleAds.BindAds = BindAds;
})(GoogleAds || (GoogleAds = {}));

//# sourceMappingURL=googleads.js.map
